import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../utilities/string'
import { Grid } from './Grid'
import { Image, ImageProps } from './Image'

export interface SmallHeroProps {
  blueOverlay?: boolean
  image?: ImageProps
  theme?: string
  title?: string
}

export const SmallHero = ({ blueOverlay, image, theme, title }: SmallHeroProps) => (
  <div className="relative">
    {image && (
      <div className="relative">
        <Image {...image} imgClassName="w-full h-[275px] object-cover" />

        {blueOverlay && (
          <div className="absolute inset-0 blend-multiply bg-senary-lighter"></div>
        )}
      </div>
    )}

    <Grid additionalClassName="absolute inset-0" contentAlignment="justify-center">
      <div
        className={classNames(
          'col-span-full mx-30 mt-60',
          'tb:col-start-1 tb:col-span-3',
          'sm:ml-60 sm:mr-0',
          'md:ml-0 md:mr-60',
          'lg:ml-90 lg:-mr-30',
          'xl:col-start-2 xl:col-span-2 xl:mx-0',
          'xxl:col-start-3 xxl:col-span-2'
        )}
      >
        {!isNullOrWhiteSpace(theme) && (
          <div className="font-hero-subtitle text-hero-subtitle text-neutral">
            {theme}
          </div>
        )}

        {!isNullOrWhiteSpace(title) && (
          <h1 className="font-h1 text-h1 text-neutral">{title}</h1>
        )}
      </div>
    </Grid>
  </div>
)
